import React from 'react';
import PropTypes from 'prop-types';
import { 
  Card, 
  CardContent, 
  Typography, 
  Grid, 
  Box, 
  Divider,
  Alert
} from '@mui/material';
import { CustomSelect } from '../../../../components/CustomSelect';
import { CustomInput } from '../../../../components/CustomInput';
import { ValidationError } from '../ValidationError';

export const PromotionInitiator = ({ 
  formData, 
  onInputChange,
  onNestedInputChange,
  initiators,
  formErrors = {}
}) => {
  return (
    <Card sx={{ mb: 3, boxShadow: 2 }}>
      <CardContent>
        <Typography variant="h5" sx={{ mb: 3, fontWeight: 600, color: 'black' }}>
          Инициатор акции
        </Typography>
        
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Box sx={{ mb: 3 }}>
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 500 }}>
                Выберите инициатора
              </Typography>
              <CustomSelect
                options={initiators?.initiators?.map(initiator => ({
                  label: `${initiator.name} ${initiator.surname} (${initiator.department})`,
                  value: initiator.id
                })) || []}
                value={formData.selected_initiator}
                onChange={(value) => onInputChange('selected_initiator', value)}
                placeholder="Выберите инициатора из списка"
                fullWidth
                error={!!formErrors.initiator}
              />
              <ValidationError error={formErrors.initiator} />
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Divider sx={{ my: 2 }}>
              <Typography variant="body2" color="text.secondary">
                ИЛИ
              </Typography>
            </Divider>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 500 }}>
              Создать нового инициатора
            </Typography>
            {formData.selected_initiator && (
              <Alert severity="info" sx={{ mb: 2 }}>
                <Typography variant="body2">
                  <strong>Примечание:</strong> Если вы выбрали инициатора из списка выше И заполните поля ниже, 
                  то будет создан новый инициатор, а выбранный из списка будет проигнорирован.
                </Typography>
              </Alert>
            )}
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Box>
              <CustomInput
                placeholder="Имя"
                value={formData.initiator.name}
                onChange={(e) => onNestedInputChange('initiator', 'name', e.target.value)}
                fullWidth
                error={!!formErrors.initiator_name}
              />
              <ValidationError error={formErrors.initiator_name} />
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box>
              <CustomInput
                placeholder="Фамилия"
                value={formData.initiator.surname}
                onChange={(e) => onNestedInputChange('initiator', 'surname', e.target.value)}
                fullWidth
                error={!!formErrors.initiator_surname}
              />
              <ValidationError error={formErrors.initiator_surname} />
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box>
              <CustomInput
                placeholder="Отдел"
                value={formData.initiator.department}
                onChange={(e) => onNestedInputChange('initiator', 'department', e.target.value)}
                fullWidth
                error={!!formErrors.initiator_department}
              />
              <ValidationError error={formErrors.initiator_department} />
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box>
              <CustomInput
                placeholder="Номер телефона"
                value={formData.initiator.phone}
                onChange={(e) => onNestedInputChange('initiator', 'phone', e.target.value)}
                fullWidth
                error={!!formErrors.initiator_phone}
              />
              <ValidationError error={formErrors.initiator_phone} />
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

PromotionInitiator.propTypes = {
  formData: PropTypes.object.isRequired,
  onInputChange: PropTypes.func.isRequired,
  onNestedInputChange: PropTypes.func.isRequired,
  initiators: PropTypes.array,
  formErrors: PropTypes.object
};
